import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Global auth guard: any 401 from a protected endpoint means the server session is gone
// (idle timeout, logout, or a stale/absent session). Force a full re-login — the browser
// Back button or a reopened tab cannot restore an authenticated state.
let _redirecting = false;
let _sessionLocked = false;
const PUBLIC_PATHS = new Set([
  "/",
  "/login",
  "/forgot-password",
  "/reset-password",
  "/setup-password",
  "/privacy",
  "/terms",
]);

const isPublicScreen = () => {
  if (typeof window === "undefined") return false;
  return PUBLIC_PATHS.has(window.location.pathname);
};

// While the inactivity lock overlay is open it owns session recovery (password unlock).
// Background 401s must not hard-redirect and bypass the password prompt.
export function setSessionLocked(v) { _sessionLocked = v; }
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/google") || url.includes("/auth/unlock");
    if (status === 401 && !error?.config?.suppressAuthRedirect && !isAuthCall && !_sessionLocked && !isPublicScreen()
      && typeof window !== "undefined") {
      if (!window.location.pathname.startsWith("/login") && !_redirecting) {
        _redirecting = true;
        try { window.sessionStorage.clear(); } catch (e) { /* ignore */ }
        window.location.replace("/login?expired=1");
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e) {
  const raw = e?.response?.data;
  if (typeof raw === "string" && (raw.includes("<html") || raw.length > 300))
    return "The server could not complete this request right now. Please retry in a moment.";
  const detail = raw?.detail;
  if (detail == null) {
    if (e?.response?.status >= 500)
      return "The server could not complete this request right now. Please retry in a moment.";
    return e?.message || "Something went wrong. Please try again.";
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
